import { MessageAIDraftComponent } from '../../component/MessageAIDraftComponent/MessageAIDraftComponent';

export interface MessageAIDraftContainerProps {
}

export const MessageAIDraftContainer = () => (
  <MessageAIDraftComponent />
);
